import { cva } from 'class-variance-authority';

const dialogBaseStyles = ['shadow', 'flex', 'p-2'];

const dialogStylesSAG = cva([
  ...dialogBaseStyles,
  'bg-[#F3F3F0]',
  'dark:bg-[#23233C]',
]);
const dialogStylesSHS = cva([
  ...dialogBaseStyles,
  'bg-white',
  'dark:bg-[#1a1a1a]',
]);

export { dialogStylesSAG, dialogStylesSHS };
